.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-4);
  min-height: var(--control-height);
  margin-bottom: var(--space-5);
}

.crumbs {
  flex: 1 1 auto;
  min-width: 0;
}

.trail {
  composes: plain-list from global;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
  font: var(--text-footnote);
  letter-spacing: var(--tracking-footnote);
  color: var(--label-2);
}

.crumb,
.parent {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.crumb::after,
.parent::after {
  content: "›";
  color: var(--label-3);
}

.crumbLink {
  color: var(--label-2);
  border-radius: var(--radius-tag);
}

.crumbLink:hover {
  color: var(--label);
}

.here {
  color: var(--label);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.end {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin-left: auto;
}

.siblings {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font: var(--text-footnote);
  color: var(--label-2);
  font-variant-numeric: tabular-nums;
}

.arrow {
  display: inline-grid;
  place-items: center;
  min-width: 28px;
  height: 28px;
  border-radius: var(--radius-control);
  color: var(--label);
  font: var(--text-headline);
  text-decoration: none;
}

a.arrow:hover {
  background: var(--fill);
}

.off {
  color: var(--label-3);
  opacity: 0.5;
}

.count {
  padding: 0 var(--space-1);
}

.manager {
  font: var(--text-footnote);
  color: var(--label-2);
  white-space: nowrap;
}

.manager:hover {
  color: var(--label);
}

@media (max-width: 719px) {
  .crumb,
  .here,
  .manager {
    display: none;
  }

  .parent::after {
    content: none;
  }

  .parent::before {
    content: "‹";
    color: var(--label-2);
  }

  .arrow {
    min-width: 44px;
    height: 44px;
  }
}
